import { render } from "./XDownloadModal.vue?vue&type=template&id=0b8c29fc&scoped=true"
import script from "./XDownloadModal.vue?vue&type=script&lang=js"
export * from "./XDownloadModal.vue?vue&type=script&lang=js"

import "./XDownloadModal.vue?vue&type=style&index=0&id=0b8c29fc&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8c29fc"]])

export default __exports__